export const msalConfig = {
  auth: {
    clientId: "3e071778-b824-44e9-9d78-33a435c0ead4",
    authority: "https://login.microsoftonline.com/893db92d-2b9c-400b-b342-d7e0fb5a80ad",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    navigateToLoginRequestUrl: true
  }
};

export const loginRequest = {
  scopes: ["openid", "profile", "User.Read", "Mail.Send"],
  prompt: "select_account"
};
